import { render, staticRenderFns } from "./extraConfigList.vue?vue&type=template&id=7ddaf000"
import script from "./extraConfigList.vue?vue&type=script&lang=js"
export * from "./extraConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports